import React from "react";

export const submissionTypeTitle = {
  FIRST_DRAFT: "project:draft_submission",
  FINAL_FILES: "project:final_submission",
};
